import React from 'react';
import Helmet from 'react-helmet';
import { graphql, Link } from 'gatsby';
import HeaderMain from '../components/HeaderMain';
import Footer from '../components/Footer';
import HeroSingle from '../components/pages/HeroSingle';
import BirthdayPartiesSlider from '../components/pages/BirthdayPartiesSlider';
import whyhostimg from '../images/whyhostimg.jpg';
import expectimg2 from '../images/expectimg2.jpg';
import LineFull from '../images/linefull.jpg';
import PriceLine from '../images/pricline.png';
import HireDJ from '../images/hiredjimg.jpg';
import HirePhoto from '../images/hirephotoimg.jpg';
import SetupImg from '../images/setupimg.jpg';
import WifiStar from '../images/wifistar.png';
import GreenLogo from '../images/greenlogo.jpg';
import SEO from '../components/seo';
import '../styles/app.scss';

const BirthDay = ({ data }) => {
    const { wordpressPage: post } = data;
    const test_title = data.wordpressPage.yoast_title;
    const new_seo_title = test_title.replace('&#039;', "'");

    return (
        <>
            <SEO
                title={new_seo_title}
                meta={data.wordpressPage.yoast_meta}
                description={
                    post.yoast_json_ld[0].wordpress__graph[0].description
                }
            />
            <HeaderMain />
            <HeroSingle pageTitle={post.title} />

            <section className="page-section smallestwdt" id="bookparty">
                <div className="container">
                    <h2 className="bluetxt">BOOK YOUR BIRTHDAY PARTY!</h2>

                    <div className="bookawrap">
                        <a
                            href={`tel:${post.acf.party_call_us_number}`}
                            className="wrtsbtn yellowbtn fullbtn"
                            style={{ padding: '20px' }}
                        >
                            CALL US TODAY: {post.acf.party_call_us_number}
                        </a>
                        <a
                            href="https://ecom.roller.app/werockthespectrumsomerville/parties/en/home"
                            className="wrtsbtn yellowbtn fullbtn"
                            style={{ marginTop: '10px', padding: '20px' }}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Book Your Party
                        </a>
                    </div>
                    <img src={LineFull} alt="linefull" />
                </div>
            </section>

            <section
                className="page-section respitesec notoppaddsec"
                id="toplftcarous"
            >
                <div className="container">
                    <div className="container flexwrap">
                        <div className="openplft">
                            <div
                                id="myCarousel3"
                                className="carousel slide"
                                data-ride="carousel"
                            >
                                <BirthdayPartiesSlider
                                    galleryImages={post.acf.bp_gallery}
                                />
                            </div>
                        </div>
                        {/* <div className="whylistlft flexbox todwn">
                        <img
                            className="whiteborderimg"
                            src={
                                post.acf.bp_why_image.localFile.childImageSharp
                                    .fluid.src
                            }
                            alt="why hosting"
                        />
                    </div> */}

                        <div className="whylistrgt flexbox toup">
                            <h2
                                className="bluetxt"
                                dangerouslySetInnerHTML={{
                                    __html: post.acf.bp_why_title,
                                }}
                            />
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: post.acf.bp_why_reasons,
                                }}
                            />
                        </div>
                    </div>
                    {/* <div className="openplft">
                         <div
                            id="myCarousel3"
                            className="carousel slide display_none"
                            data-ride="carousel"
                        >
                            <BirthdayPartiesSlider
                                galleryImages={post.acf.bp_gallery}
                            />
                        </div>
						
                        <div
                            className="display_none"
                            dangerouslySetInnerHTML={{
                                __html: post.acf.bp_book_online_code_widget,
                            }}
                        /> 
                    </div>*/}

                    {/* <div className="openprgt">
                        <h2
                            className="bluetxt display_none"
                            dangerouslySetInnerHTML={{
                                __html: post.acf.bp_title,
                            }}
                        />
                        <div
                        className="display_none"
                            dangerouslySetInnerHTML={{
                                __html: post.acf.bp_content,
                            }}
                        /> 
                    </div>*/}
                </div>
            </section>

            <section
                className="whywelist page-section bg-primary text-white display_none"
                id="openpbasic"
            >
                <div className="container middlewdt flexwrap">
                    <div className="flexbox toup">
                        <h2
                            className="yellowtxt"
                            dangerouslySetInnerHTML={{
                                __html: post.acf.bp_what_to_expect_title,
                            }}
                        />
                        <div
                            dangerouslySetInnerHTML={{
                                __html: post.acf.bp_what_to_expect_content,
                            }}
                        />
                    </div>

                    <div className="flexbox todwn">
                        <img
                            className="whiteborderimg"
                            src={
                                post.acf.bp_what_to_expect_image.localFile
                                    .childImageSharp.fluid.src
                            }
                            alt="whitebordering"
                        />
                    </div>
                </div>
                {/* <div className="container flexwrap">
                    <div className="whylistlft flexbox todwn">
                        <img
                            className="whiteborderimg"
                            src={
                                post.acf.bp_why_image.localFile.childImageSharp
                                    .fluid.src
                            }
                            alt="why hosting"
                        />
                    </div>

                    <div className="whylistrgt flexbox toup">
                        <h2
                            className="yellowtxt"
                            dangerouslySetInnerHTML={{
                                __html: post.acf.bp_why_title,
                            }}
                        />
                        <div
                            dangerouslySetInnerHTML={{
                                __html: post.acf.bp_why_reasons,
                            }}
                        />
                    </div>
                </div> */}
            </section>

            {/* <section
                className="page-section bg-secondary text-white openphours"
                id="pricingsec"
            >
                <div className="container middlewdt flexwrap">
                    <div className="flexbox toup">
                        <h2
                            className="yellowtxt"
                            dangerouslySetInnerHTML={{
                                __html: post.acf.bp_what_to_expect_title,
                            }}
                        />
                        <div
                            dangerouslySetInnerHTML={{
                                __html: post.acf.bp_what_to_expect_content,
                            }}
                        />
                    </div>

                    <div className="flexbox todwn">
                        <img
                            className="whiteborderimg"
                            src={
                                post.acf.bp_what_to_expect_image.localFile
                                    .childImageSharp.fluid.src
                            }
                            alt="whitebordering"
                        />
                    </div>
                </div>
            </section> */}

            <section className="page-section centersec nopaddbottsec">
                <div className="container smallestwdt">
                    <h2
                        className="bluetxt"
                        dangerouslySetInnerHTML={{
                            __html: post.acf.bp_pricing_title,
                        }}
                    />
                 {/*   <p
                        dangerouslySetInnerHTML={{
                            __html: post.acf.bp_pricing_description,
                        }}
                    />  */}
                    <>
                        <div style={{ height: '30px', marginBottom: '4%' }} />

                        <div className="openplft" style={{ textAlign: 'center' }}>
                            <h4>Want more info or have burning questions?</h4>
                            <div
                                style={{
                                    position: 'relative',
                                    width: '100%',
                                    height: 0,
                                    paddingTop: '141.4286%',
                                    paddingBottom: 0,
                                    boxShadow: '0 2px 8px 0 rgba(63,69,81,0.16)',
                                    marginTop: '1.6em',
                                    marginBottom: '0.9em',
                                    overflow: 'hidden',
                                    borderRadius: '8px',
                                    willChange: 'transform',
                                }}
                            >
                                <iframe
                                    loading="lazy"
                                    style={{
                                        position: 'absolute',
                                        width: '100%',
                                        height: '100%',
                                        top: 0,
                                        left: 0,
                                        border: 'none',
                                        padding: 0,
                                        margin: 0,
                                    }}
                                    src="https://www.canva.com/design/DAGev8ouvKI/3CkMMFAFRBQYkC5HlMAqQw/view?embed"
                                    allowFullScreen={true}
                                    allow="fullscreen"
                                >
                                </iframe>
                            </div>

                            <a
                                href="https://www.canva.com/design/DAGev8ouvKI/3CkMMFAFRBQYkC5HlMAqQw/view?utm_content=DAGev8ouvKI&amp;utm_campaign=designshare&amp;utm_medium=embeds&amp;utm_source=link"
                                target="_blank"
                                rel="noopener"
                            ></a>
                        </div>

                        <div className="openprgt" style={{ textAlign: 'center' }}>
                            <h4>See our Party Social Story to send to guests:</h4>
                            <div
                                style={{
                                    position: 'relative',
                                    width: '100%',
                                    height: 0,
                                    paddingTop: '141.4286%',
                                    paddingBottom: 0,
                                    boxShadow: '0 2px 8px 0 rgba(63,69,81,0.16)',
                                    marginTop: '1.6em',
                                    marginBottom: '0.9em',
                                    overflow: 'hidden',
                                    borderRadius: '8px',
                                    willChange: 'transform',
                                }}
                            >
                                <iframe
                                    loading="lazy"
                                    style={{
                                        position: 'absolute',
                                        width: '100%',
                                        height: '100%',
                                        top: 0,
                                        left: 0,
                                        border: 'none',
                                        padding: 0,
                                        margin: 0,
                                    }}
                                    src="https://www.canva.com/design/DAGPxRyANTg/7Wjz-3hc_4iO46pH9pHJBQ/view?embed"
                                    allowFullScreen={true}
                                    allow="fullscreen"
                                >
                                </iframe>
                            </div>

                            <a
                                href="https://www.canva.com/design/DAGPxRyANTg/7Wjz-3hc_4iO46pH9pHJBQ/view?utm_content=DAGPxRyANTg&amp;utm_campaign=designshare&amp;utm_medium=embeds&amp;utm_source=link"
                                target="_blank"
                                rel="noopener"
                            ></a>
                        </div>
                    </>

                    <img className="linemar nomartopimg" src={LineFull} alt="linefull" />

                    {/* <div className="packagesdiv">
                        {post.acf.bp_pricing_list.map((item, i) => (
                            <div
                                className="pricingbox bg-primary text-white"
                                key={i}
                            >
                                <h2>
                                    <span
                                        className="yellowtxt"
                                        dangerouslySetInnerHTML={{
                                            __html: item.bp_price_title,
                                        }}
                                    />
                                    <br />
                                    {item.bp_price_ammount}
                                </h2>
                                <img src={PriceLine} alt="priceline" />
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: item.bp_price_package_content,
                                    }}
                                />
                            </div>
                        ))}
                    </div> */}
                  
             {/*        <div className="iframe-bp-package">
                        
                        <iframe src="https://www.canva.com/design/DAF-ORZYFO4/view?embed"

                        /> 
                        <iframe src="https://www.canva.com/design/DAF6kIsuOkw/view?embed"
                            
                        />

                    </div>  */}

                    {/* <p><a href="https://www.canva.com/design/DAF6kIsuOkw/view?utm_content=DAF6kIsuOkw&utm_campaign=designshare&utm_medium=embeds&utm_source=link" target="_blank" rel="noopener">BIRTHDAY PARTIES - ADELAIDE WEBSITE </a> by Belinda Grant </p>  */}
                       
                </div>
                <div className="oplayhealwrap book_party_btn">
                    <div
                        style={{
                            position: 'relative',
                            width: '100%',
                            height: 0,
                            paddingTop: '141.8919%',
                            paddingBottom: 0,
                            boxShadow: '0 2px 8px 0 rgba(63,69,81,0.16)',
                            marginTop: '1.6em',
                            marginBottom: '0.9em',
                            overflow: 'hidden',
                            borderRadius: '8px',
                            willChange: 'transform',
                        }}
                    >
                        <iframe
                            loading="lazy"
                            style={{
                                position: 'absolute',
                                width: '100%',
                                height: '100%',
                                top: 0,
                                left: 0,
                                border: 'none',
                                padding: 0,
                                margin: 0,
                            }}
                            src="https://www.canva.com/design/DAGfywmJbG4/MyGv8P9lOJBhT3dZf1uPtA/view?embed"
                            allowFullScreen={true}
                            allow="fullscreen"
                        >
                        </iframe>
                    </div>

                    <a
                        href="https://www.canva.com/design/DAGfywmJbG4/MyGv8P9lOJBhT3dZf1uPtA/view?utm_content=DAGfywmJbG4&amp;utm_campaign=designshare&amp;utm_medium=embeds&amp;utm_source=link"
                        target="_blank"
                        rel="noopener"
                    ></a>
                </div>             
            </section>

            <section className="page-section centersec notoppaddsec">
                <div className="container smallestwdt">
                    <img className="linemar" src={LineFull} alt="linefull" />


                    <div className="greenlft">
                        <img src={GreenLogo} alt="greenlogo" />
                    </div>

                    <div className="greenrgt">
                        <h2 className="bluetxt">We Use Only Green Products</h2>
                        <p className="biggertxt lastitem">
                            We believe in keeping our precious ones healthy and
                            safe. Our gym is cleaned daily at the end of the day
                            with only green products.
                        </p>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default BirthDay;

export const pageQuery = graphql`
    query($id: String!) {
        wordpressPage(id: { eq: $id }) {
            id
            title
            slug
            content
            acf {
                bp_book_online_code_widget
                bp_content
                bp_gallery {
                    id
                    localFile {
                        id
                        childImageSharp {
                            fluid {
                                src
                            }
                        }
                    }
                }
                bp_hire_a_dj_content
                bp_hire_a_dj_image {
                    localFile {
                        childImageSharp {
                            fluid {
                                src
                            }
                        }
                    }
                }
                bp_hire_a_dj_title
                bp_hire_photographer_content
                bp_hire_photographer_title
                bp_open_play_unlimited_link
                bp_pricing_description
                bp_pricing_title
                bp_private_playdates_title
                bp_private_playdates_content
                bp_set_open_air_content
                bp_title
                bp_set_open_air_title
                bp_what_to_expect_content
                bp_why_title
                bp_why_reasons
                bp_what_to_expect_title
                bp_hire_photographer_image {
                    localFile {
                        childImageSharp {
                            fluid {
                                src
                            }
                        }
                    }
                }
                bp_invitation_pdf {
                    url {
                        source_url
                    }
                }
                bp_pricing_list {
                    bp_price_ammount
                    bp_price_package_content
                    bp_price_title
                }
                bp_set_open_air_image {
                    localFile {
                        childImageSharp {
                            fluid {
                                src
                            }
                        }
                    }
                }
                bp_what_to_expect_image {
                    localFile {
                        childImageSharp {
                            fluid {
                                src
                            }
                        }
                    }
                }
                party_call_us_number
                bp_why_image {
                    localFile {
                        childImageSharp {
                            fluid {
                                src
                            }
                        }
                    }
                }
            }
            yoast_meta {
                name
                property
            }
            yoast_title
            yoast_json_ld {
                wordpress__graph {
                    description
                }
            }
        }
    }
`;
